import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { Box, MenuItem, Select } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React from 'react';
import { isDisabledAllFieldCsv } from '../handler/KnowledgeUploadCsvHandler';

export default function DropDownOverWriteAttachment({
    selectedAttachFile,
    setSelectedAttachFile,
    handleStatus
}) {
    return (
        <div className="options-import-csv">
            <label className="label-upload-csv">
                {I18n.get('LABEL-SETTING-OVERWRITE-ATTACH-FILE')}
            </label>
            <Select
                fullWidth
                className="form-control form-control--wrap"
                select
                disabled={isDisabledAllFieldCsv(handleStatus)}
                value={selectedAttachFile}
                variant="outlined"
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    },
                    getContentAnchorEl: null
                }}
                onChange={e => setSelectedAttachFile(e.target.value)}
            >
                <MenuItem value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.UPDATE}>
                    <OverFlowTooltipWithTabsMui
                        value={I18n.get('LABEL-UPDATE-WHEN-OVERWRITE-ATTACH-FILE')}
                    />
                </MenuItem>
                <MenuItem value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.ADD}>
                    <OverFlowTooltipWithTabsMui
                        value={I18n.get('LABEL-ADD-WHEN-OVERWRITE-ATTACH-FILE')}
                    />
                </MenuItem>
                <MenuItem
                    value={Constant.UPLOAD_CSV_KNOWLEDGE.TYPE_OVERWRITE_ATTACH_FILE.NO_CHANGE}
                >
                    <OverFlowTooltipWithTabsMui
                        value={I18n.get('LABEL-NO-CHANGE-WHEN-OVERWRITE-ATTACH-FILE')}
                    />
                </MenuItem>
            </Select>
        </div>
    );
}
